
class ProductVariantPhoneSelector extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[data-tab-value]');
    this.contents = this.querySelectorAll('[data-tab-content]');
    this.init();
  }

  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.handleTabClick(tab));
    });
  }

  handleTabClick(selectedTab) {
    const tabValue = selectedTab.getAttribute('data-tab-value');
    
    this.tabs.forEach(tab => {
      if (tab === selectedTab) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    });

    this.contents.forEach(content => {
      if (content.getAttribute('data-tab-content') === tabValue) {
        content.classList.remove('hidden');
      } else {
        content.classList.add('hidden');
      }
    });
  }
}

customElements.define('product-variant-phone-selector', ProductVariantPhoneSelector);